import {} from '@angular/core';
import { CodeTypeModel }                from '../core/models/code-type';
import { InspectionTemplateGroup }     from './inspection.template.group.service';
import { InspectionTemplateGroupModel } from './models/inspection.template.group';
import { InspectionTemplateItemModel }  from './models/inspection.template.item';
import { InspectionTemplateModel }      from './models/inspection.template';
import { ApiService }                   from '../api/api.service';

export class InspectionTemplate implements InspectionTemplateModel {
  comment1_label : string;
  comment2_label : string;
  description    : string;
  id             : string;
  name           : string;

  groupOptions   : Array<CodeTypeModel>;
  groupOrderings : Array<number>;
  groups         : Array<InspectionTemplateGroup>;
  groupsToDelete : Array<InspectionTemplateGroup>;
  types          : Array<CodeTypeModel>;

  constructor (
    template: InspectionTemplateModel,
    groups  : Array<CodeTypeModel>,
    types   : Array<CodeTypeModel>,
    private apiService: ApiService
  ) {


    this.comment1_label = template.comment1_label;
    this.comment2_label = template.comment2_label;
    this.description    = template.description;
    this.id             = template.id;
    this.name           = template.name;

    this.groupOptions   = groups;
    this.groupOrderings = [];
    this.groups         = this.initializeGroups(template.inspection_template_items_attributes);
    this.groupsToDelete = [];
    this.types          = types;

    this.resetOrderings();


  }

  /**
   * Items carry AngularJS form controller references (keys prefixed with "$$")
   * which break Angular's JSON serialisation. Strip them before saving.
   * REFERENCE: WS-5428
   */
  cleanupItemsForSave ( items : Array<any> ) : Array<any> {
    return items.map(( item ) => {
      delete item.form;

      return item;
    });
  }

  copy ( name : string ) : Promise<any> {


    return this.apiService.post('/inspection_templates/copy_inspection_template', { id: this.id, name });


  }

  initializeGroups ( items : Array<InspectionTemplateItemModel> ) : Array<InspectionTemplateGroup> {
    if (!items || !items.length) {

      return [];

    }

    const groupCodes : Array<string>                  = [];
    const groups     : Array<InspectionTemplateGroup> = [];

    items.forEach(( item : InspectionTemplateItemModel ) => {
      if (groupCodes.indexOf(item.inspection_group) < 0) {
        groupCodes.push(item.inspection_group);
      }
    });

    for (let i = 0; i < groupCodes.length; i++) {
      const matchingItems  = items.filter(( item : InspectionTemplateItemModel ) => item.inspection_group === groupCodes[i]);
      const matchingOption = this.groupOptions.filter(( option : CodeTypeModel ) => option.code === groupCodes[i])[0] || {};

      groups.push(new InspectionTemplateGroup({
        code       : matchingOption.code,
        description: matchingOption.description,
        items      : matchingItems,
        ordering   : matchingItems[0].group_ordering
      } as InspectionTemplateGroupModel, this.types));
    }

    return groups;
  }

  resetOrderings () : void {
    this.groupOrderings = [];

    this.groups.forEach(( _group : InspectionTemplateGroup, index : number ) => {
      this.groupOrderings.push(index + 1);
    });
  }

  orderGroups () : void {
    this.groups.sort(( groupA : InspectionTemplateGroup, groupB : InspectionTemplateGroup ) => groupA.ordering - groupB.ordering);

    this.groups.forEach(( group : InspectionTemplateGroup, index : number ) => {
      group.ordering = index + 1;
    });
  }

  addGroup ( group : InspectionTemplateGroupModel ) : void {


    group.ordering = this.groups.length + 1;

    this.groups.push(new InspectionTemplateGroup(group, this.types));
    this.groupOrderings.push(this.groups.length);


  }

  removeGroup ( index : number ) : void {
    const group = this.groups.splice(index, 1)[0];

    group.items.forEach(( item : InspectionTemplateItemModel ) => {
      item._destroy = '1';
    });

    this.groupsToDelete.push(group);

    this.resetOrderings();
    this.orderGroups();
  }

  reorderGroup ( group : InspectionTemplateGroup ) : void {
    const filteredGroup = this.groups.filter(( item : InspectionTemplateGroup ) => item.code !== group.code);

    for (let i = 0; i < filteredGroup.length; i++) {


      filteredGroup[i].ordering++;


    }

    filteredGroup.push(group);

    this.groups = filteredGroup;

    this.orderGroups();
  }

  save () : Promise<InspectionTemplateModel> {
    const template : InspectionTemplateModel = {
      id                                  : this.id,
      name                                : this.name,
      description                         : this.description,
      comment1_label                      : this.comment1_label,
      comment2_label                      : this.comment2_label,
      inspection_template_items_attributes: []
    };

    this.groups.forEach(( group : InspectionTemplateGroup ) => {
      const items         = this.cleanupItemsForSave(group.items);
      const itemsToDelete = this.cleanupItemsForSave(group.itemsToDelete);

      template.inspection_template_items_attributes = template.inspection_template_items_attributes.concat(items, itemsToDelete);
    });

    this.groupsToDelete.forEach(( group : InspectionTemplateGroup ) => {
      const items = this.cleanupItemsForSave(group.items);

      template.inspection_template_items_attributes = template.inspection_template_items_attributes.concat(items);
    });

    return this.id
      ? this.apiService.patch('/inspection_template', template, 'inspection_template')
      : this.apiService.post('/inspection_templates', template, 'inspection_template');
  }
}
